import { jsx as l } from "react/jsx-runtime";
import { c as p } from "react/compiler-runtime";
import { FormControl as s } from "@mui/material";
import { forwardRef as f } from "react";
const F = f((m, e) => {
  const o = p(5);
  let r;
  o[0] !== m ? ({
    ...r
  } = m, o[0] = m, o[1] = r) : r = o[1];
  let t;
  return o[2] !== r || o[3] !== e ? (t = /* @__PURE__ */ l(s, { ref: e, ...r }), o[2] = r, o[3] = e, o[4] = t) : t = o[4], t;
});
export {
  F as FormControl
};
